import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { StatementsExpensesFeesRoute } from 'borrower/routes/statements/StatementsExpensesFeesRoute';
import { StatementsOutstandingLedgerRoute } from 'borrower/routes/statements/StatementsOutstandingLedgerRoute';

export const StatementsRouter = () => (
  <Switch>
    <Route
      exact
      path="/statements/outstanding-ledger"
      component={StatementsOutstandingLedgerRoute}
    />
    <Route
      exact
      path="/statements/expenses-fees"
      component={StatementsExpensesFeesRoute}
    />
  </Switch>
);
